/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useStateContext } from "../../../../contexts/ThemeContext";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link } from "react-router-dom";
import { ReactComponent as LockIcon } from "../../../../assets/settingPage/sideBar/lock.svg";
import { ReactComponent as LockIconDark } from "../../../../assets/settingPage/sideBar/lock-dark.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/settingPage/eye.svg";
import { ReactComponent as CloseEyeIcon } from "../../../../assets/settingPage/eye-slash.svg";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { updatePassword } from "../../../../redux/slices/user/userSlice";
import {
  resetUser as userReset,
  viewUser,
} from "../../../../redux/slices/user/userSlice";
import useLocales from "../../../../hooks/useLocales";
import MobileBottomLogoutBtn from "../../../../components/dashboard/MobileBottomLogoutBtn";

import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";
import useSettings from "../../../../hooks/useSettings";

const Security = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveSettingSubNav } = useStateContext();
  const [cPasswordVisible, setCPasswordVisible] = useState(false);
  const [nPasswordVisible, setNPasswordVisible] = useState(true);
  const [subLoading, setSubLoading] = useState(false);

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const userId = useSelector((state) => state?.user?.user?.userid);

  // update account details response
  const {
    updatePasswordError,
    updatePasswordSuccess,
    updatePasswordLoading,
    updatePasswordErrorMsg,
    updatePasswordState,
  } = useSelector((state) => state?.adminUser);
  const { status: statusupdatePassword, message: messageupdatePassword } =
    useSelector((state) => state?.adminUser?.updatePasswordState);

  useEffect(() => {
    if (statusupdatePassword === "Success" && updatePasswordSuccess) {
      toast.success(messageupdatePassword);
      dispatch(viewUser(userId));
      dispatch(userReset());
    } else if (statusupdatePassword === "failed" && updatePasswordSuccess) {
      toast.error(messageupdatePassword);
    }
    if (updatePasswordError) {
      toast.error(updatePasswordErrorMsg);
    }
    dispatch(userReset());
  }, [updatePasswordLoading, updatePasswordState]);

  const savePassword = async (e) => {
    // console.log("full data form****************", e);
    setSubLoading(true);

    const data = {
      password: e.password,
      password_confirmation: e.password_confirmation,
    };
    await dispatch(updatePassword(data));
    setSubLoading(false);
  };

  useEffect(() => {
    setActiveSettingSubNav("security");
    return () => {
      setActiveSettingSubNav(null);
    };
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Security Setting | Bil.Bio</title>
        <meta property="og:title" content="Security Setting | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="mt-10 mb-10 md:hidden ">
        <Link className="flex items-center gap-3" to={"/dashboard/setting"}>
          <div className="flex items-center justify-center ">
            {darkMode ? (
              <LeftArrowDark
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {translate("cms.security")}
          </h6>
        </Link>
      </div>
      <div className="w-full bg-white dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
        <form onSubmit={handleSubmit((data) => savePassword(data))}>
          <div className="min-h-[calc(100vh_-_335px)] flex flex-col justify-between overflow-y-scroll">
            <div>
              <h1 className="text-body_copy2_black dark:text-color_v1_dark lg:text-custom_h6">
                {translate("addBlock.security_")}
              </h1>
              <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-font_dark_color">
                {translate("addBlock.enter_password_twice")}.
              </p>
              <hr className="mt-4 lg:mt-5 dark:border-color_dark" />
              <div>
                <div>
                  <div className="mt-6 lg:mt-[30px]">
                    <p className=" text-small1_bold lg:text-body_copy1_b dark:text-color_v1_dark">
                      {translate("label.change_password")}
                    </p>
                    <div className="grid gap-5 lg:gap-[30px] mt-6 lg:mt-5 grid-cols-1 lg:grid-cols-2">
                      <div>
                        <label
                          htmlFor="nPassword"
                          className="block lg-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("addBlock.new_password")}
                        </label>
                        <div className="relative">
                          <div className="absolute flex justify-center items-center inset-y-0 start-[13px] md:start-[15px]">
                            {darkMode ? (
                              <LockIconDark
                                width={21}
                                height={21}
                                className={`${
                                  errors?.password
                                    ? "stroke-state_color_error"
                                    : "stroke-[#FFFFFF]"
                                }`}
                              />
                            ) : (
                              <LockIcon
                                width={21}
                                height={21}
                                className={`${
                                  errors?.password
                                    ? "stroke-state_color_error"
                                    : "stroke-[#1E1E1E]"
                                }`}
                              />
                            )}
                          </div>
                          <input
                            type={nPasswordVisible ? "text" : "password"}
                            {...register("password", {
                              required: `${translate("auth.pass_required")}`,
                              validate: {
                                maxLength: (v) =>
                                  v.length >= 8 ||
                                  `${translate(
                                    "addBlock.password_must_8_characters"
                                  )}`,
                                matchPattern: (v) =>
                                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
                                    v
                                  ) ||
                                  `${translate(
                                    "addblock.password_must_8_characters"
                                  )}, ${translate(
                                    "addBlock.including_uppercase_letter"
                                  )}`,
                              },
                            })}
                            id="nPassword"
                            className={`bg-transparent p-[13px] py-[5px] lg:p-[15px] lg:py-[7px] px-[45px] lg:px-[45px] border border-light_bg_v2  text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                              errors?.password
                                ? "border-state_color_error placeholder:text-state_color_error "
                                : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                            }`}
                            placeholder={translate(
                              "addBlock.enter_new_password"
                            )}
                          />
                          <div
                            onClick={() =>
                              setNPasswordVisible(!nPasswordVisible)
                            }
                            className="absolute flex justify-center items-center inset-y-0 end-[13px] md:end-[15px] cursor-pointer"
                          >
                            {nPasswordVisible ? (
                              <EyeIcon
                                className={`${
                                  errors?.password
                                    ? "stroke-state_color_error"
                                    : darkMode
                                    ? "stroke-[#FFFFFF]"
                                    : "stroke-[#292D32]"
                                }`}
                              />
                            ) : (
                              <CloseEyeIcon
                                className={`${
                                  errors?.password
                                    ? "stroke-state_color_error"
                                    : darkMode
                                    ? "stroke-[#FFFFFF]"
                                    : "stroke-[#292D32]"
                                }`}
                              />
                            )}
                          </div>
                        </div>
                        {errors?.password && (
                          <small className="text-state_color_error text-small3">
                            {errors?.password.message}
                          </small>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="cPassword"
                          className="block lg-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                        >
                          {translate("addBlock.confirm_password")}
                        </label>
                        <div className="relative">
                          <div className="absolute flex justify-center items-center inset-y-0 start-[13px] md:start-[15px]">
                            {darkMode ? (
                              <LockIconDark
                                width={21}
                                height={21}
                                className={`${
                                  errors?.password
                                    ? "stroke-state_color_error"
                                    : "stroke-[#FFFFFF]"
                                }`}
                              />
                            ) : (
                              <LockIcon
                                width={21}
                                height={21}
                                className={`${
                                  errors?.password
                                    ? "stroke-state_color_error"
                                    : "stroke-[#1E1E1E]"
                                }`}
                              />
                            )}
                          </div>
                          <input
                            type={cPasswordVisible ? "text" : "password"}
                            {...register("password_confirmation", {
                              required: `${translate(
                                "addBlock.password_confirmation_required"
                              )}`,
                              validate: (value) =>
                                value === watch("password") ||
                                `${translate("addBlock.passwords_not_match")}`,
                            })}
                            id="cPassword"
                            className={`bg-transparent p-[13px] lg:p-[15px] py-[5px] lg:py-[7px] px-[45px] lg:px-[45px] border border-light_bg_v2  text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:outline-none block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                              errors?.password_confirmation
                                ? "border-state_color_error placeholder:text-state_color_error "
                                : "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                            }`}
                            placeholder={translate(
                              "addBlock.enter_confirm_password"
                            )}
                          />
                          <div
                            onClick={() => {
                              setCPasswordVisible(!cPasswordVisible);
                            }}
                            className="absolute flex justify-center items-center inset-y-0 end-[13px] md:end-[15px] cursor-pointer"
                          >
                            {cPasswordVisible ? (
                              <EyeIcon
                                className={`${
                                  errors?.password_confirmation
                                    ? "stroke-state_color_error"
                                    : darkMode
                                    ? "stroke-[#FFFFFF]"
                                    : "stroke-[#292D32]"
                                }`}
                              />
                            ) : (
                              <CloseEyeIcon
                                className={`${
                                  errors?.password_confirmation
                                    ? "stroke-state_color_error"
                                    : darkMode
                                    ? "stroke-[#FFFFFF]"
                                    : "stroke-[#292D32]"
                                }`}
                              />
                            )}
                          </div>
                        </div>
                        {errors?.password_confirmation && (
                          <small className="text-state_color_error text-small3">
                            {errors?.password_confirmation.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <hr className="mt-[38.5px] lg:mt-10" />
                  <div className="mt-[30px] lg:mt-10 grid grid-cols-1 xl:grid-cols-2 gap-[30px] lg:gap-[40px]">
                    <div className="flex flex-col gap-[30px] xl:gap-[40px] ">
                      <div className="flex flex-col gap-5 xl:gap-7 ">
                        <p className="hidden md:block text-small1_bold lg:text-body_copy1_b text-heading_color">
                          {translate("label.Factor_authentication")}
                        </p>
                        <p className="md:hidden text-small1_bold lg:text-body_copy1_b text-heading_color">
                          {translate("label.Factor_authentication_2")}
                        </p>
                        <p className="mt-1 text-small1 xl:mt-0 text-font_light_color">
                          {translate(
                            "addBlock.factor_authentication_description"
                          )}
                        </p>
                        <div className="flex items-center justify-center">
                          <img src={QrImg} alt="" />
                        </div>
                      </div>
                      <div>
                        <label
                          htmlFor="key"
                          className="block lg-[1.5px] lg:mb-2 text-small2 lg:text-body_copy2 text-heading_color"
                        >
                          {translate("secret_key")}
                        </label>
                        <input
                          type="text"
                          id="key"
                          className="bg-transparent p-[13px] pl-[10px] lg:p-[15px] border border-light_bg_v2  text-heading_color text-small2 lg:text-body_copy2 rounded-md focus:border-font_light_color focus:outline-none block w-full "
                          placeholder="funls6486rg4gwr8vsdjk"
                        />
                      </div>
                    </div>
                          </div> */}
                  <div className="mt-10 md:mt-[50px] text-center md:text-end">
                    <button
                      type="submit"
                      className={`rounded-full w-full md:w-fit md:p-3 py-[6px] md:pt-[13px] bg-main_color text-white text-small3_b md:text-small1_bold ${
                        subLoading ? "opacity-70 md:px-20" : "md:px-10"
                      }`}
                    >
                      {subLoading ? (
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                      ) : (
                        `${translate("addBlock.save_changes")}`
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <MobileBottomLogoutBtn />
    </>
  );
};

export default Security;
